import { FormControl, FormGroup } from '@angular/forms';

/**
 * Wiedza o formacie zapisu opaski w PATCH /manager/patient/{imei}.
 *
 * Backend odrzuca nieznane pole bledem 400 "This form should not contain extra
 * fields." — i to na CALYM zadaniu, nie na jednym polu. Dodanie kontrolki do
 * formularza opaski psuje wiec zapis wszystkiego, lacznie z danymi pacjenta.
 * Lista ponizej to kontrakt potwierdzony przez backend (2026-08-06); mieszanka
 * konwencji nazw jest po ich stronie przypadkowa, a warianty snake_case pol
 * camelCase sa odrzucane.
 */
export const BAND_ALLOWED_FIELDS = [
  'fall', 'imei', 'measure', 'vol', 'minHr', 'maxHr', 'isHr', 'isSat', 'minimumSat',
  'phones', 'steps', 'zone', 'simNumber', 'timezone', 'full_batt_notif', 'low_batt_notif',
  'wear_notif', 'not_wear_notif', 'sos_notif', 'fall_notif', 'zone_notif', 'name_notif',
  'shr_notif', 'sms_limit', 'firmware_version', 'lang_band', 'beacon', 'night_mode',
  'night_start', 'night_stop', 'whitelistNumbers', 'whiteListAlias', 'isAlarmZone',
  'isImmo', 'immoTime', 'immoThreshold', 'isImmoAlarm', 'stepNotification',
  'operatingMode', 'aac', 'ivs'
];

/**
 * Pola opaski podpiete pod <input type="checkbox">. Backend czyta je jako 1/0 (tak
 * przychodza z GET-a), a CheckboxControlValueAccessor po kliknieciu wpisuje boolean —
 * do API szlo wiec raz 1, raz true. Backend traktuje je rownowaznie, ale konwersja
 * jest po stronie PHP, gdzie string "false" jest prawda, a "0" falszem. Wysylamy typ
 * logiczny, zeby zaden string nigdy nie zdecydowal o wartosci flagi.
 *
 * Pola liczbowe i select-y sa tu celowo pominiete (minHr, measure, vol,
 * operatingMode, lang_band, sms_limit, beacon...).
 */
export const BAND_BOOLEAN_FLAGS = [
  'isHr', 'isSat', 'isAlarmZone', 'night_mode', 'full_batt_notif', 'low_batt_notif',
  'wear_notif', 'not_wear_notif', 'sos_notif', 'fall_notif', 'zone_notif',
  'name_notif', 'shr_notif', 'aac', 'ivs', 'isImmo', 'isImmoAlarm', 'isZoneAlarm'
];

/** Tylko gdy GET zwrócił `is_zone_alarm`: api2 sprzed SDLY-3086 odrzuca `isZoneAlarm` jak każde nadmiarowe pole. */
export function addZoneAlarmControl(bandForm: FormGroup, band: any): void {
  if (band.hasOwnProperty('is_zone_alarm')) {
    bandForm.setControl('isZoneAlarm', new FormControl(band.is_zone_alarm));
  }
}

/** Zwraca nowy obiekt — bez mutowania wejscia. */
export function normalizeBandFlags<T extends object>(band: T): T {
  const normalized: any = { ...(band as any) };
  BAND_BOOLEAN_FLAGS.forEach(flag => {
    if (normalized.hasOwnProperty(flag)) {
      normalized[flag] = !!normalized[flag];
    }
  });
  return normalized;
}

// "+" opcjonalny: ~36 tys. opasek na SP ma SIM jako 9 cyfr bez kierunkowego (ERP/backfill)
// i sztywne "+ i 10-20 cyfr" blokowalo zapis calych ustawien pacjenta.
export const BAND_SIM_NUMBER_PATTERN = /^\+?\d{9,20}$/;
